import React from 'react';
import {
    editCompanyAutoConnectNotFoundType,
    editCompanyAutoConnectType,
    updateAutoConnectStatus
} from "../../../../../../../../services/company/api";
import Translate, {t} from "../../../../../../../../components/Translate";
import config from "../../../../../../../../config";
import ChoiceButtons from "../../../../../../../../components-new/form/ChoiceButtons";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";
import Switch from "../../../../../../../../components-new/form/Switch";
import colors from "../../../../../../../../utils/Colors";
import GalleryHorizontalEndIcon from "../../../../../../../../assets/icons/GalleryHorizontalEndIcon";
import MenuIcon from "../../../../../../../../assets/icons/MenuIcon";

const AutoConnectConfig = ({user, features, client, autoConnectInfo, setAutoConnectInfo, isFetching}) => {

    const handleCheckboxChange = () => {
        updateAutoConnectStatus(client.id, autoConnectInfo.enabled)
            .then(() => {
                setAutoConnectInfo(prev => ({
                    ...prev,
                    enabled: !autoConnectInfo.enabled,
                }));
            })
            .catch(error => console.error('Error updating auto-connect status:', error));
    };

    const handleTypeChange = (value) => {
        setAutoConnectInfo(prev => ({
            ...prev,
            type: value,
        }));

        editCompanyAutoConnectType(client.id, value);
    };

    const handleNotFoundTypeChange = (value) => {
        setAutoConnectInfo(prev => ({
            ...prev,
            notFoundType: value,
        }));

        editCompanyAutoConnectNotFoundType(client.id, value);
    };

    // A tariff without skills leaves one option here, and ChoiceButtons then draws
    // it as a value rather than as a choice of one.
    const autoConnectOptions = [
        {
            value: 'DISTRIBUTE_EQUALLY',
            label: t({text: "distributeEqually", user})
        },
        ...(features.includes(config.features.SKILLS)
            ? [{
                value: 'BY_SKILLS',
                label: t({text: "bySkills", user})
            }]
            : [])
    ];

    const notFoundOptions = [
        {
            value: 'MOVE_TO_UN_MANAGED_LIST',
            label: t({text: "moveToUnmanagedList", user}),
            icon: <MenuIcon strokeWidth={2} stroke="currentColor" width={18} height={18}/>
        },
        {
            value: 'MOVE_TO_QUEUE',
            label: t({text: "moveToQueue", user}),
            icon: <GalleryHorizontalEndIcon strokeWidth={2} stroke="currentColor" width={18} height={18}/>
        }
    ];

    const isOff = !autoConnectInfo.enabled;

    return (
        <SettingCard
            titleKey="autoConnectLogic"
            toggle={
                <Switch
                    checked={!!autoConnectInfo.enabled}
                    onChange={handleCheckboxChange}
                    style={{color: colors.silverBlue}}
                />
            }
        >
            <div
                className={'setting-body' + (isOff ? ' setting-body--off' : '')}
                style={{opacity: isFetching ? 0.5 : 1}}
            >
                <div className="setting-field">
                    <span className="setting-label"><Translate text="operatorConnectionLogic"/></span>

                    <ChoiceButtons
                        value={autoConnectInfo.type || 'DISTRIBUTE_EQUALLY'}
                        options={autoConnectOptions}
                        onChange={handleTypeChange}
                        disabled={isFetching || isOff}
                    />
                </div>

                <div className="setting-field">
                    <span className="setting-label"><Translate text="notFoundTypeExp"/></span>

                    <ChoiceButtons
                        value={autoConnectInfo.notFoundType || 'MOVE_TO_UN_MANAGED_LIST'}
                        options={notFoundOptions}
                        onChange={handleNotFoundTypeChange}
                        disabled={isFetching || isOff}
                    />
                </div>
            </div>
        </SettingCard>
    );
};

export default AutoConnectConfig;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/AutoConnectConfig.jsx